var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1763092083728,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 11260,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M804.571429 348.598857q-32.036571 14.262857-69.12 19.456 38.838857-22.820571 53.174857-66.852571-37.156571 21.723429-76.580571 29.110857-34.889143-37.741714-87.405714-37.741714-49.737143 0-84.845714 35.108571t-35.108571 84.845714q0 16.603429 2.852571 27.428571-73.728-4.022857-138.313143-37.156571t-109.714286-88.576q-16.603429 28.598857-16.603429 60.562286 0 65.170286 52.004571 99.986286-26.843429-0.585143-57.124571-14.848l0 1.170286q0 42.861714 28.598857 76.288t70.290286 41.398857q-16.603429 4.534857-29.110857 4.534857-7.460571 0-22.308571-2.267429 11.995429 35.986286 42.569143 59.465143t69.412571 23.990857q-66.267429 51.419429-149.138286 51.419429-14.848 0-28.598857-1.682286 84.553143 53.686857 184.027429 53.686857 64 0 120.027429-20.260571t96.036571-54.272 68.827429-78.262857 42.861714-92.598857 13.970286-96.256q0-10.313143-0.585143-15.433143 35.986286-25.746286 59.977143-62.317714zM950.857143 237.714286l0 548.571429q0 68.022857-48.274286 116.297143t-116.297143 48.274286l-548.571429 0q-68.022857 0-116.297143-48.274286t-48.274286-116.297143l0-548.571429q0-68.022857 48.274286-116.297143t116.297143-48.274286l548.571429 0q68.022857 0 116.297143 48.274286t48.274286 116.297143z",
    fill: "#003366",
    "p-id": 11261
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterSquare);
export default __webpack_public_path__ + "static/media/twitter-square.713ec0d2de21697295ba7fbc2d408cad.svg";
export { ForwardRef as ReactComponent };